import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { FaClipboardList, FaPlus } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageHeader from "../../../Components/PageHeader";
import Spin from "../../../Components/Spin";
import SwithBtn from "../../../Components/SwithBtn";
import api from "../../../Utils/api";
import {
  deleteApplication,
  setApplications,
  updateApplication,
} from "../../../store/reducer/application";
import { logOut } from "../../../store/reducer/auth";
import { setLoading } from "../../../store/reducer/loading";

const Applications = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const applications = useSelector((state) => state.application);
  const auth = useSelector((state) => state.auth);
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [activation, setActivation] = useState("");

  const handleAppActif = async (id, checked) => {
    setActivation(id);
    const [filtre] = applications.filter((app) => app.id === id);
    const dataApplication = { ...filtre, actif: checked };
    // console.log(filtre, dataApplication);
    try {
      const { data } = await api.put(`application/${id}`, dataApplication);
      if (!data.application) {
        toast.error("Vérifier vos données avant la soumission.");
        return;
      }
      dispatch(updateApplication(dataApplication));
      setFilteredData((prev) =>
        [...prev].map((app) => (app.id === id ? dataApplication : app))
      );
      toast.success("Mise à jour éffectuée.");
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        dispatch(logOut());
        navigate("/login");
      }
    } finally {
      setActivation("");
    }
  };

  const columns = [
    {
      name: "Nom",
      selector: (row) => row.labelle,
      grow: 4,
    },
    {
      name: "Téléchargement",
      selector: (row) =>
        row.nbr_telechargement === null ? "0" : row.nbr_telechargement.length,
      grow: 1,
    },
    {
      name: "Status",
      selector: (row) => (row.actif ? "Actif" : "Inactif"),
      grow: 1,
    },
    {
      name: "Activation/Désactivation",
      selector: (row) =>
        activation === row.id ? (
          <Spin size="sm" />
        ) : (
          <SwithBtn
            id={row.id}
            checked={row.actif}
            onChange={({ target }) => handleAppActif(row.id, target.checked)}
          />
        ),
      grow: 1,
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <Button
            variant="outline-info"
            className="mr-2"
            onClick={() => navigate(`/application/${row.id}`)}
          >
            <FaClipboardList />
          </Button>
          {auth.roles?.includes("ROLE_ADMIN") && (
            <Button
              variant="outline-danger"
              onClick={() => handleDeleteApplication(row.id)}
            >
              <MdDelete />
            </Button>
          )}
        </>
      ),
      grow: 1,
    },
  ];

  const handleDeleteApplication = async (id) => {
    if (!window.confirm("Voulez-vous supprimer cette application ?")) return;
    try {
      const { data } = await api.delete(`application/${id}`);

      if (data.Message) {
        dispatch(deleteApplication(id));
        setFilteredData((prev) => [...prev].filter((app) => app.id !== id));
        toast.success("Application supprimée avec succès.");
      }
    } catch (error) {
      toast.error("Vérifier vos données avant la soumission.");
      if (error.response.status === 401) {
        navigate("/login");
      }
    }
  };

  const handleSearch = () => {
    setFilteredData(
      [...applications].filter((item) =>
        item.labelle.toLowerCase().includes(search.toLowerCase())
      )
    );
  };

  const tableHearderStyle = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#ccc",
      },
    },
  };

  const loadApplications = async () => {
    dispatch(setLoading(true));
    try {
      const response = await api.get("application");
      const applicationsData = response.data.applications;
      dispatch(setApplications(applicationsData));
      setFilteredData(applicationsData);
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/login");
      }
    } finally {
      dispatch(setLoading(false));
    }
  };

  document.title = "DashBoard | Applications";
  useEffect(() => {
    loadApplications();
  }, []);

  return (
    <>
      <PageHeader page="Applications" />

      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <div className="card-tools">
                <Button
                  className="btn btn-success mr-3"
                  onClick={() => navigate("/nouvelapplication")}
                >
                  <FaPlus /> Ajouter
                </Button>
              </div>
            </div>
            <div className="card-body">
              <DataTable
                customStyles={tableHearderStyle}
                columns={columns}
                data={filteredData}
                pagination
                responsive
                highlightOnHover
                subHeader
                subHeaderComponent={
                  <input
                    className="form-control w-25"
                    placeholder="Rechercher une application..."
                    type="text"
                    onKeyUp={handleSearch}
                    value={search}
                    onChange={({ target }) => setSearch(target.value)}
                  />
                }
              />
            </div>
          </div>
        </div>
      </section>
      {/* /.content */}
    </>
  );
};

export default Applications;
